import FullPageContainer from "components/FullPageContainer";
import { Heading } from "iparque-components";
import styled, { css } from "styled-components";
import { getAppearFromLeft, getAppearFromRight } from "theme/animations";
import { breakpoints } from "theme/breakpoints";

const squareBorderWidthXl = "100px";
const squareBorderWidthLg = "70px";
const squareBorderWidthMd = "50px";
const squareBorderWidthSm = "20px";
const contentContainerMarginXl = "30%";
const containerMaxWidth = "1920px";

export const Container = styled.div`
  max-height: 0;
  max-width: ${containerMaxWidth};
  margin: 0 auto;
  overflow: hidden;
  transition: max-height 1s;

  @media (min-width: ${breakpoints.lg}) {
    transform: translateY(-100px);
  }
`;

export const StyledFullPageContainer = styled(FullPageContainer)`
  padding-bottom: 250px;
  box-sizing: border-box;
  min-height: unset;

  @media (max-width: ${breakpoints.md}) {
    padding-bottom: 350px;
  }
`;

export const Square = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 60%;
  min-height: 950px;
  padding: 50px 0;
  border: ${squareBorderWidthXl} solid ${({ theme }) => theme.colors.sensing};

  @media (max-width: ${breakpoints.lg}) {
    border-width: ${squareBorderWidthLg};
    width: 100%;
    height: unset;
    padding-bottom: 0;
  }

  @media (max-width: ${breakpoints.md}) {
    border-width: ${squareBorderWidthMd};
  }

  @media (max-width: ${breakpoints.sm}) {
    border-width: ${squareBorderWidthSm};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: 90%;
  min-width: calc(
    min(100vw, ${containerMaxWidth}) - ${contentContainerMarginXl}
  );
  margin-left: calc(${contentContainerMarginXl} - ${squareBorderWidthXl});

  @media (max-width: ${breakpoints.lg}) {
    flex-direction: column;
    align-items: stretch;
    min-width: unset;
    margin-left: unset;
    width: 100%;
  }
`;

export const TextContainer = styled.div<{ isOnScreen: boolean }>`
  ${({ isOnScreen }) =>
    isOnScreen
      ? css`
          animation: ${getAppearFromLeft("-20%")} 1s;
          animation-fill-mode: both;
          animation-delay: 0.5s;
        `
      : ""}

  @media (min-width: ${breakpoints.lg}) {
    flex: 2;
    max-width: 375px;
    margin-right: 140px;
  }

  @media (max-width: ${breakpoints.lg}) {
    margin: 0 50px 50px;
  }

  @media (max-width: ${breakpoints.sm}) {
    margin: 0 20px 50px;
  }
`;

export const VideoContainer = styled.div<{ isOnScreen: boolean }>`
  flex: 3;
  min-height: 550px;
  background-color: white;

  ${({ isOnScreen }) =>
    isOnScreen
      ? css`
          animation: ${getAppearFromRight("10%")} 1s;
          animation-fill-mode: both;
          animation-delay: 0.5s;
        `
      : ""}

  @media (max-width: ${breakpoints.lg}) {
    flex: unset;
    height: 400px;
  }
`;

export const StyledHeading = styled(Heading)`
  line-height: 1.1em;
  margin-bottom: 60px;
`;
